(() => {
  const mobile = window.matchMedia('(max-width: 599.98px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();

  function initialize(video) {
    if (initialized.has(video)) return;
    initialized.add(video);

    const sync = () => {
      if (reducedMotion.matches) {
        video.pause();
        video.classList.remove('is-playing');
        return;
      }

      const source = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      if (!source) return;
      if (video.getAttribute('src') !== source) {
        video.classList.remove('is-playing');
        video.setAttribute('src', source);
        video.load();
      }
      video.play().catch(() => video.classList.remove('is-playing'));
    };

    video.addEventListener('playing', () => video.classList.add('is-playing'));
    video.addEventListener('error', () => video.classList.remove('is-playing'));
    mobile.addEventListener('change', sync);
    reducedMotion.addEventListener('change', sync);
    sync();
  }

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-easyfeet-hero-video]').forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
